import { lightTokens, darkTokens } from "../styles/tokens";

export type ThemeMode = "light" | "dark";

export function resolveTheme(mode: "AUTO" | ThemeMode): ThemeMode {
  if (mode !== "AUTO") return mode;
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function applyTheme(host: HTMLElement, mode: ThemeMode): void {
  const styleId = "cg-theme-style";

  let style = host.shadowRoot?.getElementById(
    styleId,
  ) as HTMLStyleElement | null;
  if (!style) {
    style = document.createElement("style");
    style.id = styleId;
    host.shadowRoot?.appendChild(style);
  }

  style.textContent = mode === "dark" ? darkTokens : lightTokens;
}
